module.exports = __webpack_public_path__ + "static/media/userIcon.4f10caa0.svg";